import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

import WhoWhatDetails, { Step } from './WhoWhatDetails';
import Who from './Who';
import What from './What';
import Details from './Details';
import Spinner from '../../components/Spinner';
import { BackendUser } from '../../types';
import { Program } from './data';
import { useFlipOIDC } from '../../components/FlipOIDC';

import './styles.css';

export default function Main() {
  const { token } = useFlipOIDC();

  const [step, setStep] = React.useState<Step>(Step.Who);
  const [loading, setLoading] = React.useState(true);
  const [users, setUsers] = React.useState<BackendUser[]>([]);
  const [selectedUser, setSelectedUser] = React.useState<BackendUser>();
  const [selectedProgram, setSelectedProgram] = React.useState<Program>();

  const handleUserChange = (user: BackendUser) => {
    setSelectedUser(user);
  };

  const handleWhatChange = (program: Program) => {
    setSelectedProgram(program);
    setStep(Step.Details);
  };

  const handleWhoNext = () => {
    setStep(Step.What);
  };

  const handleWhatBack = () => {
    setStep(Step.Who);
  };

  const handleDetailsBack = () => {
    setStep(Step.What);
  };

  const handleDone = () => {
    toast.success(`Congratulations, thanks for recognising ${selectedUser.first_name}!`);
    setStep(Step.Who);
    setSelectedProgram(undefined);
    setSelectedUser(undefined);
  };

  React.useEffect(() => {
    async function load() {
      const { data } = await axios.get<BackendUser[]>('/api/v2/user', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(data);
      setLoading(false);
    }

    load();
  }, [token]);

  if (loading) {
    return (
      <Spinner fullPage />
    );
  }

  return (
    <div className="mobile-layout">
      <div className="mobile-content">
        <div className="m-16">
          <WhoWhatDetails step={step} />
          <div className="recognition-container">
            <div className="recognition-container-card">
              {
                step === Step.Who && (
                  <Who
                    user={selectedUser}
                    users={users}
                    onChange={handleUserChange}
                    onNext={handleWhoNext}
                  />
                )
              }
              {
                step === Step.What && (
                  <What
                    onBack={handleWhatBack}
                    onChange={handleWhatChange}
                  />
                )
              }
              {
                step === Step.Details && (
                  <Details
                    program={selectedProgram}
                    onBack={handleDetailsBack}
                    onDone={handleDone}
                  />
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
